export default __webpack_public_path__ + "static/overtake_thumbnail-8aa5b00e2c4875e039de0e3a8ed57e4c.png";